import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Faltan las variables de entorno REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. Revisa tu archivo .env (ver .env.example).'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
